/*
 * @Descripttion: 
 * @version: 
 * @Author: szj
 * @Date: 2023-03-13 17:54:10
 * @LastEditors: szj
 * @LastEditTime: 2025-04-10 11:58:07
 */
// 可拖拽组件：pc和Mobile
function useMove(el: any, binding: any) {
    // console.log(11,el);
    // 查找拖拽手柄，如果指定了选择器则使用选择器，否则使用整个元素
    const dragHandle = binding?.value ? el.querySelector(binding.value) : el;
    
    if (!dragHandle) {
        console.warn('拖拽手柄未找到');
        return;
    }
    
    // cursor:move
    el.style.position = 'fixed';
    dragHandle.style.cursor = 'move';
    el.style.zIndex = '1000';
    let offsetX: number, offsetY: number, oL: number, oT: number, oLeft: number, oTop: number;
    const browser = {
        versions: function () {
            const u = navigator.userAgent;
            return {
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //判断设备
                //  ..... 其他设备信息
            };
        }(),
    }
    if (!browser.versions.mobile) {//Pc
        if (el != null && dragHandle != null) {
            dragHandle.addEventListener('mousedown', function (event: any) {
                if (event.button == 0 && el != null) {
                    const lexObj: any = getComputedStyle(el);
                    offsetX = event.pageX - el.offsetLeft + parseInt(lexObj['margin-left']);
                    offsetY = event.pageY - el.offsetTop + parseInt(lexObj['margin-top']);
                    const move = function (event: any) {
                        if (el != null) {
                            let x = event.pageX - offsetX;
                            let y = event.pageY - offsetY;
                            if (x < 0) {
                                x = 0;
                            } else if (x > document.documentElement.clientWidth - el.offsetWidth) {
                                x = document.documentElement.clientWidth - el.offsetWidth
                            }
                            if (y < 0) {
                                y = 0;
                            } else if (y > document.documentElement.clientHeight - el.offsetHeight) {
                                y = document.documentElement.clientHeight - el.offsetHeight
                            }
                            // console.log(48,x,document.documentElement.clientWidth , el.offsetWidth);
                            // if (x > 300) {
                            // }
                            el.style.left = x + 'px';
                            el.style.top = y + 'px';
                        }
                        return false;
                    }
                    document.addEventListener('mousemove', move);
                    const stop = function () {
                        document.removeEventListener('mousemove', move);
                        document.removeEventListener('mouseup', stop);
                    }
                    document.addEventListener('mouseup', stop);
                }
                return false;
            });
        }
    } else { //Mobile
        if (el != null && dragHandle != null) {
            const maxW = window.innerWidth - el.offsetWidth;
            const maxH = window.innerHeight - el.offsetHeight;
            const defaultEvent = function (e: any) {
                e.preventDefault();
            }
            dragHandle.addEventListener('touchstart', function (e: any) {
                const ev = e || window.event;
                const touch = ev.targetTouches[0];
                oL = touch.clientX - el.offsetLeft;
                oT = touch.clientY - el.offsetTop;
                document.addEventListener("touchmove", defaultEvent, false);
                el.addEventListener('touchmove', function (e: any) {
                    const ev = e || window.event;
                    const touch = ev.targetTouches[0];
                    oLeft = touch.clientX - oL;
                    oTop = touch.clientY - oT;
                    if (oLeft < 0) {
                        oLeft = 0;
                    } else if (oLeft >= maxW) {
                        oLeft = maxW;
                    }
                    if (oTop < 0) {
                        oTop = 0;
                    } else if (oTop >= maxH) {
                        oTop = maxH;
                    }
                    el.style.left = oLeft + 'px';
                    el.style.top = oTop + 'px';
                });
                el.addEventListener('touchend', function () {
                    document.removeEventListener("touchmove", defaultEvent);
                });
            });
        }
    }
}


// export default useMove;

// 拖拽的指令
// const drag = {
//     beforeMount(el: any, binding: any) {
//         // console.log(105,el,binding);
        
//       // 自定义属性，判断是否可拖拽
//       if (!binding.value) return
//       const dialogHeaderEl = el.querySelector('.vedio-vedio')
//       const dragDom = el.querySelector('.vedio-content')
//       dialogHeaderEl.style.cssText += ';cursor:move;position:fixed;'
//       // dragDom.style.cssText += ';bottom:0px;'
   
//       // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
//       const sty = (function () {
//         if ((document.body as any).currentStyle) {
//           // 在ie下兼容写法
//           return (dom: any, attr: any) => dom.currentStyle[attr]
//         }
//         return (dom: any, attr: any) => getComputedStyle(dom, null)[attr]
//       })()
   
//       dialogHeaderEl.onmousedown = (e: any) => {
//         // console.log(124);
        
//         // 鼠标按下，计算当前元素距离可视区的距离
//         const disX = e.clientX - dialogHeaderEl.offsetLeft
//         const disY = e.clientY - dialogHeaderEl.offsetTop
//         const screenWidth = document.body.clientWidth // body当前宽度
//         const screenHeight = document.documentElement.clientHeight // 可见区域高度(应为body高度，可某些环境下无法获取)
   
//         const dragDomWidth = dragDom.offsetWidth // 对话框宽度
//         const dragDomheight = dragDom.offsetHeight // 对话框高度
   
//         const minDragDomLeft = dragDom.offsetLeft
//         const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth
   
//         const minDragDomTop = dragDom.offsetTop
//         const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight
   
//         // 获取到的值带px 正则匹配替换
//         let styL = sty(dragDom, 'left')
//         // 为兼容ie
//         if (styL === 'auto') styL = '0px'
//         let styT = sty(dragDom, 'top')
//         if (styT === 'auto') styT = '0px'
        
//         // console.log(styL)
//         // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
//         if (styL.includes('%')) {
//           styL = +document.body.clientWidth * (+styL.replace(/%/g, '') / 100)
//           styT = +document.body.clientHeight * (+styT.replace(/%/g, '') / 100)
//         } else {
//           styL = +styL.replace(/px/g, '')
//           styT = +styT.replace(/px/g, '')
//         }
   
//         document.onmousemove = function (e) {
//           // 通过事件委托，计算移动的距离
//           let left = e.clientX - disX
//           let top = e.clientY - disY
//         console.log(146,top,minDragDomTop);

//           // 边界处理
//           if (-(left) > minDragDomLeft) {
//             left = -(minDragDomLeft)
//           } else if (left > maxDragDomLeft) {
//             left = maxDragDomLeft
//           }
   
//           if (-(top) > minDragDomTop) {
//             top = -(minDragDomTop)
//           } else if (top > maxDragDomTop) {
//             top = maxDragDomTop
//           }
   
//           // 移动当前元素
//           dialogHeaderEl.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`
//         //   console.log(175,dialogHeaderEl.style.cssText,top , styT);
          
//         }
   
//         document.onmouseup = function (e: any) {
//           document.onmousemove = null
//           document.onmouseup = null
//         }
//         return false
//       }
//     }
//   }
  // 挂载，注册
  const directives = {
    install: function (app: any) {
      app.directive('dialogDrag', {
        mounted(el: any, binding: any) {
          useMove(el, binding);
        }
      })
    }
  };
  export default directives;